export const PAGE_META = {
  customers: {
    title: "customers.list.meta.html_page_title",
    description: "customers.list.meta.html_page_description",
  },
  organizations: {
    title: "organizations.list.meta.html_page_title",
    description: "organizations.list.meta.html_page_description",
  },
  credentials: {
    title: "credentials.list.meta.html_page_title",
    description: "credentials.list.meta.html_page_description",
  },
  credentialsCreate: {
    title: "credentials.create.meta.html_page_title",
    description: "credentials.create.meta.html_page_description",
  },
  credentialsEdit: {
    title: "credentials.edit.meta.html_page_title",
    description: "credentials.edit.meta.html_page_description",
  },
  seasons: {
    title: "seasons.list.meta.html_page_title",
    description: "seasons.list.meta.html_page_description",
  },
} as const;
